import { createSlice } from "@reduxjs/toolkit";

const emptyResourceHolder = {
  meta: {
    count: 0,
    lastFetched: null,
  },
  list: [],
};

export const initialState = {
  devices: { ...emptyResourceHolder },
  partners: { ...emptyResourceHolder },
  pbxes: { ...emptyResourceHolder },
  accounts: { ...emptyResourceHolder },
  phoneNumbers: { ...emptyResourceHolder },
};

const backstageSlice = createSlice({
  name: "backstage",
  initialState,
  reducers: {
    setDeviceStore: (state, action) => {
      state.devices = {
        list: action.payload.devices,
        meta: { count: action.payload.count, lastFetched: new Date().toString() },
      };
    },
    setPartnerStore: (state, action) => {
      state.partners = {
        list: action.payload.partners,
        meta: { count: action.payload.count, lastFetched: new Date().toString() },
      };
    },
    setPbxStore: (state, action) => {
      state.pbxes = {
        list: action.payload.pbxes,
        meta: { count: action.payload.count, lastFetched: new Date().toString() },
      };
    },
    setAccountStore: (state, action) => {
      state.accounts = {
        list: action.payload.accounts,
        meta: { count: action.payload.count, lastFetched: new Date().toString() },
      };
    },
    setPhoneNumberStore: (state, action) => {
      state.phoneNumbers = {
        list: action.payload.phoneNumbers,
        meta: { count: action.payload.count, lastFetched: new Date().toString() },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase("root/clearAuthData", () => {
      return initialState;
    });
  },
});

export const { setDeviceStore, setPartnerStore, setPbxStore, setAccountStore, setPhoneNumberStore } =
  backstageSlice.actions;

export default backstageSlice.reducer;
